import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { Label } from "../../components/ui/label";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../../components/ui/select";
import { RadioGroup, RadioGroupItem } from "../../components/ui/radio-group";
import { Checkbox } from "../../components/ui/checkbox";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../../components/ui/table";
import { Save, X, Edit, Trash2 } from "lucide-react";
import { postRequest } from "../../services/mainApp.service";
import { useSelector } from "react-redux";
import { message, Popconfirm } from "antd";

const PettyCashPage = ({ open, onClose }) => {
    const [voucherNumber, setVoucherNumber] = useState("");
    const [cashInHand, setCashInHand] = useState(0);
    const [branchDeposit, setBranchDeposit] = useState(false);
    const [amount, setAmount] = useState("");
    const [partyPayment, setPartyPayment] = useState(false);
    const [transactionType, setTransactionType] = useState("Deposit");
    const [partyId, setPartyId] = useState(null);
    const [paymentMode, setPaymentMode] = useState("Cash");
    const [previousBalance, setPreviousBalance] = useState(0);
    const [pettyCashAccountMasterId, setpettyCashAccountMasterId] = useState(null);
    const [pettyCashAccountDetailId, setpettyCashAccountDetailId] = useState(null);
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);

    const [partyList, setPartyList] = useState([]);
    const [pettyCashAccountMasterList, setpettyCashAccountMasterList] = useState([]);
    const [pettyCashAccountDetailList, setpettyCashAccountDetailList] = useState([]);
    const [pettyCashAccountDetailListAll, setpettyCashAccountDetailListAll] = useState([]);
    const [pettyCashData, setPettyCashDataList] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const userData = useSelector((state) => state.authReducer);

    useEffect(() => {

        PettyCashRequest(1);
    }, []);

    // useEffect(() => {
    //     if (pettyCashAccountMasterId) {
    //         fetchpettyCashAccountDetails(pettyCashAccountMasterId);
    //     } else {
    //         setpettyCashAccountDetailList([]);
    //         setpettyCashAccountDetailId(null);
    //     }
    // }, [pettyCashAccountMasterId]);

    const PettyCashRequest = async (operationId) => {

        try {
            let selectedTerminalId = localStorage.getItem('SelectedTerminalId');
            const response = await postRequest("/PettyCash", {
                OperationId: operationId,
                CompanyId: userData.CompanyId,
                TerminalId: selectedTerminalId,
                UserId: userData.UserId,
                UserIP: "1.2.2.1",
            });

            if (response.data.Response) {

                if (operationId === 1) {
                    const pettyCashData = response.data.DataSet?.Table || [];
                    const terminalData = response.data.DataSet?.Table1 || [];
                    const cashAmountData = response.data.DataSet?.Table2 || [];
                    const accountMaster = response.data.DataSet?.Table3 || [];
                    const accountDetail = response.data.DataSet?.Table4 || [];
                    const voucherNo = response.data.DataSet?.Table5 || [];
                    const partyData = response.data.DataSet?.Table6 || [];

                    setCashInHand(cashAmountData[0]?.CashInHand || 0);
                    setpettyCashAccountMasterList(accountMaster);
                    setpettyCashAccountDetailListAll(accountDetail);
                    setVoucherNumber(voucherNo[0]?.VoucherNumber || "");
                    setPettyCashDataList(pettyCashData);
                    setPartyList(partyData);
                }
            }

        } catch (error) {
            setVoucherNumber("");
        }
    };

    const handleAmountChange = (e) => {
        const value = e.target.value;
        setAmount(value);
    };

    const handlePartyChange = (value) => {
        setPartyId(value ? parseInt(value) : null);

        const selectedParty = partyList.find((party) => party.CustomerId === parseInt(value));
        if (selectedParty) {
            setPreviousBalance(selectedParty.Balance || 0);
        } else {
            setPreviousBalance(0);
        }
    };

    const handlepettyCashAccountMasterChange = (value) => {

        setpettyCashAccountMasterId(value ? parseInt(value) : null);

        const filteredDetails = pettyCashAccountDetailListAll.filter(
            (detail) => detail.ParentId === parseInt(value)
        );
        setpettyCashAccountDetailList(filteredDetails);
        setpettyCashAccountDetailId(null);
    };

    const handlepettyCashAccountDetailChange = (value) => {
        setpettyCashAccountDetailId(value ? parseInt(value) : null);
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    };

    const validateForm = () => {
        if (!amount || parseFloat(amount) <= 0) {
            return false;
        }
        if (transactionType === "Withdraw" && !pettyCashAccountMasterId) {
            return false;
        }
        return true;
    };

    const handleRowSelect = (row) => {
        setSelectedRow(row);
        setIsEditMode(true);

        // Populate form fields with selected row data
        setAmount(row.Amount?.toString() || "");
        setTransactionType(row.CashInOutType === "IN" ? "Deposit" : "Withdraw");
        setDescription(row.Description || "");
        setpettyCashAccountMasterId(row.AccountMasterId || null);
        setpettyCashAccountDetailId(row.AccountDetailId || null);

        // Set account detail list based on selected master
        if (row.AccountMasterId) {
            const filteredDetails = pettyCashAccountDetailListAll.filter(
                (detail) => detail.ParentId === row.AccountMasterId
            );
            setpettyCashAccountDetailList(filteredDetails);
        }

        // // Set other fields if available
        // if (row.PartyId) {
        //     setPartyId(row.PartyId);
        //     setPartyPayment(true);
        // }
        // if (row.PaymentMode) {
        //     setPaymentMode(row.PaymentMode);
        // }
        // if (row.BranchDeposit !== undefined) {
        //     setBranchDeposit(row.BranchDeposit);
        // }
    };

    const handleSave = async () => {

        if (!validateForm()) {
            message.error("Please fill all required fields");
            return;
        }

        setLoading(true);
        try {
            let selectedTerminalId = localStorage.getItem('SelectedTerminalId');

            const payload = {
                OperationId: isEditMode ? 3 : 2,
                CompanyId: userData.CompanyId,
                TerminalId: selectedTerminalId,
                UserId: userData.UserId,
                UserIP: "1.2.2.1",
                CashInOutType: transactionType === "Deposit" ? "IN" : "OUT",
                Amount: parseFloat(amount),
                Description: description,
                AccountMasterId: pettyCashAccountMasterId,
                AccountDetailId: pettyCashAccountDetailId,
                PettyCashInOutId: selectedRow ? selectedRow.PettyCashInOutId : null,
                IsPartyPayment: partyPayment,
                IsPartyCheque: paymentMode === "Cheque" ? true : false,
                CustomerId: partyPayment ? partyId : null,
            };

            // Add transaction ID for update
            if (isEditMode && selectedRow) {
                payload.PettyCashTransactionId = selectedRow.PettyCashTransactionId || selectedRow.TransactionId || selectedRow.Id;
            }

            postRequest("PettyCash", payload)
                .then((response) => {

                    if (response.data.error === true) {
                        message.error(response.data.errorMessage);
                        return;
                    }

                    if (response.data.response === false) {
                        message.error(response.data.DataSet.Table.errorMessage);
                        return;
                    }

                    const data = response.data.DataSet;
                    const { Table1, Table2, Table3, Table4, Table5, Table6, Table7 } = data;

                    const pettyCashData = Table1 || [];
                    const terminalData = Table2 || [];
                    const cashAmountData = Table3 || [];
                    const accountMaster = Table4 || [];
                    const accountDetail = Table5 || [];
                    const voucherNo = Table6 || [];
                    const partyData = Table7 || [];

                    setCashInHand(cashAmountData[0]?.CashInHand || 0);
                    setpettyCashAccountMasterList(accountMaster);
                    setpettyCashAccountDetailListAll(accountDetail);
                    setVoucherNumber(voucherNo[0]?.VoucherNumber || "");
                    setPettyCashDataList(pettyCashData);
                    setPartyList(partyData);

                    message.success(response.successMessage || (isEditMode ? "Transaction updated successfully" : "Transaction saved successfully"));

                    handleReset();
                })
                .catch((error) => {
                    console.error("Error:", error);
                    message.error(isEditMode ? "Failed to update transaction" : "Failed to save transaction");
                });

        } catch (error) {
            message.error(error?.response?.data?.message || error?.message || "Failed to save transaction");
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        handleReset();
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        } else {
            window.history.back();
        }
    };

    const handleOpenChange = (open) => {
        if (!open && onClose) {
            onClose();
        }
    };

    const handleDelete = async () => {
        if (!selectedRow) {
            message.error("Please select a transaction to delete");
            return;
        }

        setLoading(true);
        try {
            let selectedTerminalId = localStorage.getItem('SelectedTerminalId');

            const payload = {
                OperationId: 4, // Assuming 4 is for delete
                CompanyId: userData.CompanyId,
                TerminalId: selectedTerminalId,
                UserId: userData.UserId,
                UserIP: "1.2.2.1",
                PettyCashInOutId: selectedRow.PettyCashInOutId,
            };

            postRequest("PettyCash", payload)
                .then((response) => {
                    if (response.data.error === true) {
                        message.error(response.data.errorMessage);
                        return;
                    }

                    if (response.data.response === false) {
                        message.error(response.data.DataSet?.Table?.errorMessage || "Failed to delete transaction");
                        return;
                    }

                    const data = response.data.DataSet;
                    const { Table1, Table2, Table3, Table4, Table5, Table6 } = data;

                    const pettyCashData = Table1 || [];
                    const terminalData = Table2 || [];
                    const cashAmountData = Table3 || [];
                    const accountMaster = Table4 || [];
                    const accountDetail = Table5 || [];
                    const voucherNo = Table6 || [];

                    setCashInHand(cashAmountData[0]?.CashInHand || 0);
                    setpettyCashAccountMasterList(accountMaster);
                    setpettyCashAccountDetailListAll(accountDetail);
                    setVoucherNumber(voucherNo[0]?.VoucherNumber || "");
                    setPettyCashDataList(pettyCashData);

                    message.success(response.successMessage || "Transaction deleted successfully");
                    handleReset();
                })
                .catch((error) => {
                    console.error("Error:", error);
                    message.error("Failed to delete transaction");
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (error) {
            message.error(error?.response?.data?.message || error?.message || "Failed to delete transaction");
            setLoading(false);
        }
    };

    const handleReset = () => {
        setAmount("");
        setPartyPayment(false);
        setTransactionType("Deposit");
        setPartyId(null);
        setPaymentMode("Cash");
        setpettyCashAccountMasterId(null);
        setpettyCashAccountDetailId(null);
        setDescription("");
        setBranchDeposit(false);
        setSelectedRow(null);
        setIsEditMode(false);
        setpettyCashAccountDetailList([]);
    };

    const isSaveDisabled = !validateForm();

    const content = (
        <div className="p-0 bg-white">
            <div className="grid grid-cols-12 gap-4 mb-4">
                <div className="col-span-3 space-y-2">
                    <Label htmlFor="voucherNumber">Voucher #</Label>
                    <Input
                        id="voucherNumber"
                        value={voucherNumber}
                        readOnly
                        className="bg-muted"
                    />
                </div>
                <div className="col-span-3 space-y-2">
                    <Label htmlFor="cashInHand">Cash In Hand</Label>
                    <Input
                        id="cashInHand"
                        value={cashInHand.toFixed(2)}
                        readOnly
                        className="bg-muted"
                    />
                </div>
                <div className="col-span-6 flex items-end justify-end">
                    <div className="flex items-center space-x-2">
                        <Checkbox
                            id="branchDeposit"
                            checked={branchDeposit}
                            onCheckedChange={(checked) => setBranchDeposit(checked)}
                        />
                        <Label htmlFor="branchDeposit" className="cursor-pointer">
                            Branch Deposit
                        </Label>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
                <div className="border rounded-lg p-4 min-h-[400px]">
                    <h3 className="text-base font-semibold mb-4">Transaction Details</h3>

                    <div className="space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="amount">
                                Amount <span className="text-destructive">*</span>
                            </Label>
                            <Input
                                id="amount"
                                type="number"
                                placeholder="Enter amount"
                                value={amount}
                                onChange={handleAmountChange}
                            />
                        </div>

                        <div className="flex items-center space-x-2">
                            <Checkbox
                                id="partyPayment"
                                checked={partyPayment}
                                onCheckedChange={(checked) => setPartyPayment(checked)}
                            />
                            <Label htmlFor="partyPayment" className="cursor-pointer">
                                Party Payment
                            </Label>
                        </div>

                        <div className="space-y-2">
                            <Label>Transaction Type</Label>
                            <RadioGroup
                                value={transactionType}
                                onValueChange={setTransactionType}
                                className="flex gap-4"
                            >
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="Deposit" id="deposit" />
                                    <Label htmlFor="deposit" className="cursor-pointer">
                                        Deposit
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="Withdraw" id="withdraw" />
                                    <Label htmlFor="withdraw" className="cursor-pointer">
                                        Withdraw
                                    </Label>
                                </div>
                            </RadioGroup>
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="party">Party</Label>
                            <Select
                                value={partyId?.toString() || ""}
                                onValueChange={handlePartyChange}
                                disabled={!partyPayment}
                            >
                                <SelectTrigger id="party">
                                    <SelectValue placeholder="Select Party" />
                                </SelectTrigger>
                                <SelectContent>
                                    {partyList.map((party) => (
                                        <SelectItem
                                            key={party.CustomerId}
                                            value={party.CustomerId.toString()}
                                        >
                                            {party.PhoneNumber} - {party.CustomerName}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </div>

                        <div className="space-y-2">
                            <Label>Payment Mode</Label>
                            <RadioGroup
                                value={paymentMode}
                                onValueChange={setPaymentMode}
                                className="flex gap-4"
                            >
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="Cash" id="cash" />
                                    <Label htmlFor="cash" className="cursor-pointer">
                                        Cash
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <RadioGroupItem value="Cheque" id="cheque" />
                                    <Label htmlFor="cheque" className="cursor-pointer">
                                        Cheque
                                    </Label>
                                </div>
                            </RadioGroup>
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="previousBalance">Previous Balance</Label>
                            <Input
                                id="previousBalance"
                                value={previousBalance.toFixed(2)}
                                readOnly
                                className="bg-muted"
                            />
                        </div>
                    </div>
                </div>

                <div className="border rounded-lg p-4 min-h-[400px]">
                    <h3 className="text-base font-semibold mb-4">Account Details</h3>

                    <div className="space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="pettyCashAccountMaster">
                                Account Master
                                {transactionType === "Withdraw" && (
                                    <span className="text-destructive"> *</span>
                                )}
                            </Label>
                            <Select
                                value={pettyCashAccountMasterId?.toString() || ""}
                                onValueChange={handlepettyCashAccountMasterChange}
                            // disabled={transactionType === "Deposit"}
                            >
                                <SelectTrigger id="pettyCashAccountMaster">
                                    <SelectValue placeholder="Select Account Master" />
                                </SelectTrigger>
                                <SelectContent>
                                    {pettyCashAccountMasterList.map((master) => (

                                        <SelectItem
                                            key={master.SetupDetailId}
                                            value={master.SetupDetailId.toString()}
                                        >
                                            {master.SetupDetailName}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="pettyCashAccountDetail">Account Detail
                                {transactionType === "Withdraw" && (
                                    <span className="text-destructive"> *</span>
                                )}
                            </Label>
                            <Select
                                value={pettyCashAccountDetailId?.toString() || ""}
                                onValueChange={handlepettyCashAccountDetailChange}
                            // disabled={!pettyCashAccountMasterId || transactionType === "Deposit"}
                            >
                                <SelectTrigger id="pettyCashAccountDetail">
                                    <SelectValue placeholder="Select Account Detail" />
                                </SelectTrigger>
                                <SelectContent>
                                    {pettyCashAccountDetailList.map((detail) => (
                                        <SelectItem
                                            key={detail.SetupDetailId}
                                            value={detail.SetupDetailId.toString()}
                                        >
                                            {detail.SetupDetailName}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="description">Description</Label>
                            <Textarea
                                id="description"
                                rows={4}
                                value={description}
                                onChange={handleDescriptionChange}
                                placeholder="Enter description"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-4 flex justify-between items-center">
                {isEditMode && selectedRow && (
                    <div className="text-sm text-muted-foreground">
                        Editing: {selectedRow.VoucherNumber || selectedRow.voucherNumber || "Transaction"}
                    </div>
                )}
                <div className="flex justify-end gap-2 ml-auto">
                    {isEditMode && selectedRow && (
                        <Popconfirm
                            title="Delete Transaction"
                            description="Are you sure you want to delete this transaction?"
                            onConfirm={handleDelete}
                            okText="Yes"
                            cancelText="No"
                            okButtonProps={{ danger: true }}
                        >
                            <Button
                                variant="destructive"
                                disabled={loading}
                            >
                                <Trash2 className="h-4 w-4 mr-2" />
                                Delete
                            </Button>
                        </Popconfirm>
                    )}
                    <Button
                        onClick={handleSave}
                        disabled={isSaveDisabled || loading}
                        className="bg-green-600 hover:bg-green-700"
                    >
                        <Save className="h-4 w-4 mr-2" />
                        {loading ? (isEditMode ? "Updating..." : "Saving...") : (isEditMode ? "Update" : "Save")}
                    </Button>
                    <Button variant="outline" onClick={handleCancel}>
                        {isEditMode ? "Cancel Edit" : "Cancel"}
                    </Button>
                    <Button variant="destructive" onClick={handleClose}>
                        <X className="h-4 w-4 mr-2" />
                        Close
                    </Button>
                </div>
            </div>

            <div className="mt-6">
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Voucher #</TableHead>
                            <TableHead>Date</TableHead>
                            <TableHead>Type</TableHead>
                            <TableHead>Amount</TableHead>
                            <TableHead>Account Master</TableHead>
                            <TableHead>Account Detail</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {pettyCashData && pettyCashData.length > 0 ? (
                            pettyCashData.map((row, index) => {
                                const isSelected = selectedRow && (
                                    selectedRow.PettyCashInOutId === row.PettyCashInOutId
                                );

                                return (
                                    <TableRow
                                        key={index}
                                        onClick={() => handleRowSelect(row)}
                                        className={`cursor-pointer ${isSelected ? "bg-blue-50 hover:bg-blue-100" : "hover:bg-muted/50"}`}
                                    >
                                        <TableCell>{row.VoucherNumber || row.voucherNumber || "-"}</TableCell>
                                        <TableCell>
                                            {row.TransactionDate
                                                ? new Date(row.TransactionDate).toLocaleDateString()
                                                : row.Date
                                                    ? new Date(row.Date).toLocaleDateString()
                                                    : "-"}
                                        </TableCell>
                                        <TableCell>
                                            <span className={`px-2 py-1 rounded text-xs font-medium ${(row.CashInOutType === "IN" || row.Type === "Deposit" || row.CashInOutType === "Deposit")
                                                ? "bg-green-100 text-green-800"
                                                : "bg-red-100 text-red-800"
                                                }`}>
                                                {row.CashInOutType === "IN" ? "Deposit" :
                                                    row.CashInOutType === "OUT" ? "Withdraw" :
                                                        row.Type || row.CashInOutType || "-"}
                                            </span>
                                        </TableCell>
                                        <TableCell className="font-medium">
                                            {row.Amount ? parseFloat(row.Amount).toFixed(2) : "-"}
                                        </TableCell>
                                        <TableCell>{row.AccountMasterName || row.AccountMaster || "-"}</TableCell>
                                        <TableCell>{row.AccountDetailName || row.AccountDetail || "-"}</TableCell>
                                    </TableRow>
                                );
                            })
                        ) : (
                            <TableRow>
                                <TableCell colSpan={6} className="text-center text-muted-foreground py-8">
                                    No transactions found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
        </div>
    );

    if (open !== undefined) {
        return (
            <Dialog open={open} onOpenChange={handleOpenChange}>
                <DialogContent className="sm:max-w-[90%] max-h-[90vh] overflow-y-auto">
                    <DialogHeader>
                        <DialogTitle>Cash Deposit / Withdraw</DialogTitle>
                        <DialogDescription>
                            Manage petty cash transactions including deposits and withdrawals.
                        </DialogDescription>
                    </DialogHeader>
                    {content}
                </DialogContent>
            </Dialog>
        );
    }

    return <div className="p-6">{content}</div>;
};

export default PettyCashPage;
